(function($) {
  $(function() {
    $('.video-overlay').click(function() {
      resize($(this).parent());
    });

    function resize(el) {
      // reset styles and stop all the other vids from playing
      $('.video-container').removeClass('col-sm-12');
      $('.video-container .video-overlay').removeClass('hide');
      $('.video-container .video-wrapper iframe').each(function() {
        if($(this).data('src') !== $(this).attr('src')) $(this).attr('src',$(this).attr('src').replace('?autoplay=1', ''));
      });
      // var allIframes = $('.video-wrapper').children('iframe');
      // allIframes.attr();

      // resize the selected vid
      $(el).addClass('col-sm-12');
      $(el).children('.video-overlay').addClass('hide');

      // set selected vid to autoplay
      var selectedIframe = $(el).children('.video-wrapper').children('iframe');
      selectedIframe.attr('src', selectedIframe.data('autoplay-src'));

      $("html, body").animate({ scrollTop: 0 }, "slow");
    }
  });
})(jQuery);